import Modal from 'LuxKit/Modal/Modal'
import React, { useCallback, useMemo, useRef } from 'react'
import { useIntl } from 'react-intl'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { semiFormToObject } from 'lib/forms/formUtils'
import type {
  CruiseSearchShipChipProps,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchShipChip'
import CruiseShipFilter
  from 'components/Cruises/SearchPage/Filters/Inputs/Common/CruiseSearchExtraFilter/CruiseShipFilter'
import useQueryParams from 'hooks/useQueryParams'

function ModalCruiseSearchShipChip(props: CruiseSearchShipChipProps) {
  const {
    facets,
    filterForm,
    setFilterForm,
    fetching,
    filters,
    drawerMode,
  } = props
  const intl = useIntl()
  const modalElement = useModalElementContext<number>()
  const containerRef = useRef<HTMLDivElement>(null)
  const queryParams = useQueryParams()

  const queryParamCruiseShips = useMemo(() => {
    return queryParams.getAll('cruiseShips')
  }, [queryParams])

  const countSelected = useMemo(() => {
    return queryParamCruiseShips.length || 0
  }, [queryParamCruiseShips.length])

  const closeModal = useCallback(() => {
    modalElement.resolve(countSelected)
  }, [countSelected, modalElement])

  const updateForm = useCallback(() => {
    if (containerRef.current) {
      const formValues = semiFormToObject<Record<string, any>>(containerRef.current)
      if (formValues && Object.keys(formValues).length > 0) {
        setFilterForm({ ...filterForm, ...formValues })
      } else {
        setFilterForm({ ...filterForm, cruiseShips: undefined })
      }
    }
  }, [filterForm, setFilterForm])

  const resetFilter = useCallback(() => {
    setFilterForm({ ...filterForm, cruiseShips: undefined })
    modalElement.resolve(0)
  }, [setFilterForm, filterForm, modalElement])

  const modalTitle = intl.formatMessage({
    id: '47KLa4E4Le4vsciNwQlG',
    defaultMessage: 'Cruise ships',
    description: 'Modal title for cruise ships filter in the cruise offer or booking section',
  })
  const applyLabel = intl.formatMessage({
    id: 'ZJ3mNIXEN1vnESPskMnM',
    defaultMessage: 'Apply',
    description: 'Button text to apply cruise ships filter selections',
  })
  const resetLabel = intl.formatMessage(
    {
      id: 'NiikMgC_UOAkOcYybGZh',
      defaultMessage: '{count, plural, =0 {Reset all} one {Reset all (#)} other {Reset all (#)}}',
      description: 'Button text to reset cruise ships filters with optional count of active filters',
    },
    { count: countSelected },
  )

  return <Modal
    mode={drawerMode ? 'drawer' : 'default'}
    ref={containerRef}
    title={modalTitle}
    primaryActionText={applyLabel}
    onPrimaryActionClick={closeModal}
    secondaryActionText={resetLabel}
    onSecondaryActionClick={resetFilter}
  >
    <CruiseShipFilter
      cruiseShips={filters.cruiseShips}
      facets={facets}
      onChange={updateForm}
      fetching={fetching}
    />
  </Modal>
}

export default ModalCruiseSearchShipChip
